module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-container"
  }, [_c('div', {
    staticClass: "layout-canvas-wrap"
  }, [_c('div', {
    staticClass: "layout-canvas"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('partials-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ed0a344!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/LayoutError.vue
// module id = 472
// module chunks = 2